
import { Resource } from "src/app/core/jsonapi/resource";
import { prop, required } from "@rxweb/reactive-form-validators";

export class Queue extends Resource {
    public override type = 'queues';

    @prop()
    public name!: string;

    @prop()
    public musiconhold?: string;

    @prop()
    public timeout?: number;

    @prop()
    public retry?: number;

    @prop()
    public strategy!: string;

    @prop()
    public wrapuptime?: number;

    @prop()
    public maxlen?: number;

    @prop()
    public autopause?: string;

    @prop()
    public ringinuse?: string;

    @prop()
    public announceFrequency?: number;

    @prop()
    public periodicAnnounce?: string;

    @prop()
    public periodicAnnounceFrequency?: number;
}
